/* ============
 * Contract Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    contractAggregates: [],
    addedLessorsIds: [],
    currentContract: {},
    unitOfMeasure: [],
    isHideCharts: true,
    isContractRawEditing: false,
    isInClosedPeriod: false,
    isContractSimplifiedEditing: false,
    isContractChangeCondition: false,
    isContractEventEditing: false,
    renameLessorList: [],
  },
  actions,
  getters,
  mutations
};
